import { isEvent } from "./event.js";
export function isParallelEvent(value) {
    return isEvent(value) && value.parallel !== false;
}
//# sourceMappingURL=parallel-event.js.map